export enum hubEvent {
    refreshDeviceStatus = "RefreshDeviceStatus",
    refreshDeviceJob = "RefreshDeviceJob",
    refreshDeviceJobRating = "RefreshDeviceJobRating",
    refreshDeviceHeatingProgress = "RefreshDeviceHeatingProgress",
    refreshDeviceParsingProgress = "RefreshDeviceParsingProgress",
    refreshDeviceUploadingFileProgress = "RefreshDeviceUploadingFileProgress",
    refreshCameraPreview = "RefreshCameraPreview",
    refreshExtruderPosition = "RefreshExtruderPosition",

    refreshUserProfile = "RefreshUserProfile",
    refreshStatsAndResources = "RefreshStatsAndResources",
    refreshFileUploadingProgress = "RefreshFileUploadingProgress",
    refreshFileList = "RefreshFileList",

    addTeamDevice = "AddTeamDevice",
    addTeamUser = "AddTeamUser",
    addDevice = "AddDevice",
    addGroup = "AddGroup",

    deleteTeamDevice = "DeleteTeamDevice",
    deleteTeamUser = "DeleteTeamUser",

    displayDeviceMessage = "DisplayDeviceMessage",
    
    // refreshDeviceLog = "RefreshDeviceLog",
    // refreshCameraPreview = "RefreshCameraPreview",
    // refreshGroup = "RefreshGroup",
    // refreshJob = "RefreshJob",
    // refreshNotification = "RefreshNotification",
    // refreshTeamDetails = "RefreshTeamDetails",
    // refreshTeams = "RefreshTeams",
    // refreshFileUploadProgress = "RefreshFileUploadProgress",
    // refreshStatsAndResources = "RefreshStatsAndResources",
    // refreshMaterial = "RefreshMaterial",
    // refreshJobRating = "RefreshJobRating",
    // refreshDevice = "RefreshDevice",

    // refreshDevices = "RefreshDevices",
    // refreshDeviceDetails = "RefreshDeviceDetails",
    // refreshNotifications = "RefreshNotifications",
    // refreshNumberOfNotifications = "RefreshNumberOfNotifications",
    // refreshDeviceFiles = "RefreshDeviceFiles",
    // refreshDeviceLogs = "RefreshDeviceLogs",
    // refreshDevicePrintHistory = "RefreshDevicePrintHistory",
    // refreshGroupList = "RefreshGroupList",
    // refreshTimeline = "RefreshTimeline",

    // refreshSubscriptions = "RefreshSubscriptions",
    // refreshFirmwareList = "RefreshFirmwareList",
    // refreshUploadProgress = "RefreshUploadProgress",
    // refreshUserProfile = "RefreshUserProfile",
    // refreshShelf = "RefreshShelf",
    // refreshShelfList = "RefreshShelfList",
    // refreshShelfUsersAvailable = "RefreshShelfUsersAvailable",
    // refreshShelfUsers = "RefreshShelfUsers",

    // refreshMultiStream = "RefreshMultiStream",
    // refreshMultiCameraPreview = "RefreshMultiCameraPreview",

    // addDeviceDataResponse = "AddDeviceDataResponse",
    // addDeviceGroupResponse = "AddDeviceGroupResponse",

    // refreshDeviceResponse = "RefreshDeviceResponse",
    // refreshDeviceDataResponse = "RefreshDeviceDataResponse",
    // refreshDeviceGroupResponse = "RefreshDeviceGroupResponse",
    // refreshDeviceGroupsResponse = "RefreshDeviceGroupsResponse",

    // deleteDeviceDataResponse = "DeleteDeviceDataResponse"
}